/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-08T15:42:09+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {isEqualDate} from './dateUtils';
import buttonProps from './../../../utilities/buttonProps';

/**
 * AButtonDay - used in datepicker for days control
 */
class AButtonDay extends Component {
  /**
     * react render() <AButtonDay>
     *
     * @return {object}
     */
  render() {
    const {
      date,
      onPress, // eslint-disable-line no-unused-vars
      active, // eslint-disable-line no-unused-vars
      visualState,
      ...other
    } = this.props;

    const todayClass = isEqualDate(date, new Date()) ? 'today' : '';

    return date ? (
            <div
              {...other}
              className={`a-button a-button-day ${visualState} ${todayClass}`}
              onClick={this.handleOnPress}
            >
              <div className="a-button-day__state" />
              <span className="a-button-day__label">{date.getDate()}</span>
            </div>
        ) : (
            <span className="a-button a-button-day" />
        );
  }

    /**
     * @param  {object} event
     */
    handleOnPress = (event) => {
      const {onPress, date} = this.props;
      if (onPress) onPress(date, event);
    }
}
AButtonDay.propTypes = {
  date: PropTypes.object,
  /**
     * passes (date, event)
     * @type {Function}
     */
  onPress: PropTypes.func,
  active: PropTypes.bool, // passed by buttonProps
  visualState: PropTypes.string, // passed by buttonProps
};
AButtonDay.defaultProps = {
  active: false,
  disabled: false,
};
export default buttonProps(AButtonDay);

